import styled from 'styled-components'

import theme, { breakpoint } from 'style/theme'

export default styled.div`
  .faq-container {
    margin-bottom: 50px;
    display: flex;
    flex-direction: column;
    gap: 16px;

    .header-container {
      text-align: center;
      .header {
        .ant-typography {
          font-size: 36px;
          font-family: 'Kanit-SemiBold';
        }
      }
    }
    .faq-content {
      .faq-list {
        background-color: ${theme.white};

        .ant-collapse-item.ant-collapse-item-active {
          .anticon.anticon-right.ant-collapse-arrow {
            transform: rotate(180deg);
            font-size: 20px;
          }
        }

        .ant-collapse-header {
          padding: 0;

          .question {
            width: 90%;
            .ant-typography {
              font-size: 24px;
            }
          }

          .anticon.anticon-right.ant-collapse-arrow {
            transform: rotate(90deg);
            font-size: 20px;
          }
        }

        .ant-collapse-item {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .ant-collapse-content > .ant-collapse-content-box {
          padding: 0;
        }

        .title {
          padding: 16px 0 27px 0;
          font-size: 24px;
        }

        .content {
          .ant-typography {
            font-size: 24px;

            color: #6e757c;
          }
        }
      }
    }
  }

  @media (max-width: ${breakpoint.lg}) {
    .faq-container {
      padding: 0;

      .header-container {
        .header {
          .ant-typography {
            font-size: 32px;
            font-family: 'Kanit-SemiBold';
          }
        }
      }
      .faq-content {
        .faq-list {
          .ant-collapse-content-box {
            padding: 0;
          }

          .ant-collapse-item {
            display: flex;
            flex-direction: column;
            gap: 20px;
          }

          .question {
            .ant-typography {
              font-size: 30px;
              font-family: 'Kanit-SemiBold';
            }
          }

          .content {
            font-size: 20px;
          }
        }
      }
    }
  }

  @media (max-width: ${breakpoint.md}) {
    .faq-container {
      padding: 0;

      .header-container {
        .header {
          .ant-typography {
            font-size: 20px;
            font-family: 'Kanit-SemiBold';
          }
        }
      }
      .faq-content {
        .faq-list {
          .ant-collapse-content-box {
            padding: 0;
          }

          .ant-collapse-item {
            display: flex;
            flex-direction: column;
            gap: 20px;
          }

          .ant-collapse-item.ant-collapse-item-active {
            .anticon.anticon-right.ant-collapse-arrow {
              transform: rotate(180deg);
              font-size: 14px;
            }
          }

          .ant-collapse-header {
            padding: 0;

            .question {
              .ant-typography {
                font-size: 16px;
              }
            }

            .anticon.anticon-right.ant-collapse-arrow {
              transform: rotate(90deg);
              font-size: 14px;
            }
          }

          .content {
            .ant-typography {
              font-size: 16px;
            }
          }
        }
      }
    }
  }
`
